import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Card, CardContent, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip, CircularProgress,
  TextField, MenuItem, Grid, IconButton, Tooltip, TablePagination
} from '@mui/material';
import {
  Phone, WhatsApp, InfoOutlined, FilterList
} from '@mui/icons-material';
import { api } from '../context/AuthContext';

import { useSearchParams } from 'react-router-dom';

const CommunicationHistoryPage = () => {
  const [searchParams] = useSearchParams();
  const [history, setHistory] = useState([]);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    type: searchParams.get('type') || '',
    status: ''
  });

  useEffect(() => {
    fetchHistory();
  }, [filters]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      let url = '/applications/comm-center/history';
      const params = new URLSearchParams();
      if (filters.type) params.append('type', filters.type);
      if (params.toString()) url += `?${params.toString()}`;
      
      const res = await api.get(url);
      setHistory(res.data);
    } catch (err) {
      console.error('Failed to fetch history:', err);
    } finally {
      setLoading(false);
    }
  };

  const paginatedHistory = history.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
  );
  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography
            variant="h4"
            sx={{
              color: "#1E3A8A",
              fontWeight: "bold",
              fontSize: {
                xs: "1.5rem",
                md: "2rem",
              },
            }}
            gutterBottom
        >
          Communication History
        </Typography>
        <Typography variant="body1" color="text.secondary">Detailed logs of all automated communications sent to candidates</Typography>
      </Box>

      <Card sx={{ mb: 4, borderRadius: '16px' }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                label="Communication Type"
                value={filters.type}
                onChange={(e) => {
                    setPage(0);
                    setFilters({ ...filters, type: e.target.value });
                }}
                size="small"
              >
                <MenuItem value="">All Types</MenuItem>
                <MenuItem value="voice">Voice Call</MenuItem>
                <MenuItem value="whatsapp">WhatsApp</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <TableContainer component={Paper} sx={{ borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <Table>
          <TableHead sx={{ bgcolor: '#F8FAFC' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Candidate</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Job Position</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Template</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Date & Time</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Info</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
                <TableRow><TableCell colSpan={7} align="center"><CircularProgress size={24} sx={{ my: 2 }} /></TableCell></TableRow>
            ) : history.length > 0 ? paginatedHistory.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>
                    <Typography variant="body2" fontWeight={600}>{row.first_name} {row.last_name}</Typography>
                </TableCell>
                <TableCell>{row.job_title}</TableCell>
                <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {row.type === 'voice' ? <Phone sx={{ fontSize: 16, color: '#10B981' }} /> : <WhatsApp sx={{ fontSize: 16, color: '#2563EB' }} />}
                        <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>{row.type === 'voice' ? 'Voice' : 'WhatsApp'}</Typography>
                    </Box>
                </TableCell>
                <TableCell>{row.template_name || 'Manual'}</TableCell>
                <TableCell>
                  <Chip 
                    label={row.status} 
                    size="small" 
                    color={row.status === 'delivered' ? 'success' : row.status === 'failed' ? 'error' : 'warning'} 
                    variant="soft"
                    sx={{ fontWeight: 600, textTransform: 'capitalize' }}
                  />
                </TableCell>
                <TableCell>
                    <Typography variant="body2">{new Date(row.created_at).toLocaleDateString()}</Typography>
                    <Typography variant="caption" color="text.secondary">{new Date(row.created_at).toLocaleTimeString()}</Typography>
                </TableCell>
                <TableCell>
                    {row.failure_reason && (
                        <Tooltip title={row.failure_reason}>
                            <IconButton size="small" color="error"><InfoOutlined fontSize="small" /></IconButton>
                        </Tooltip>
                    )}
                </TableCell>
              </TableRow>
            )) : (
                <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                        <Typography color="text.secondary">No records found matching filters</Typography>
                    </TableCell>
                </TableRow>
            )}
          </TableBody>
        </Table>
          <TablePagination
              component="div"
              count={history.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPageOptions={[]}
              labelRowsPerPage=""
              labelDisplayedRows={({ from, to, count }) =>
                  `Showing ${from} to ${to} of ${count} entries`
              }
          />

      </TableContainer>
    </Box>
  );
};

export default CommunicationHistoryPage;
